var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4834 10.9597C14.6581 10.3992 14.1636 9.5452 13.3228 9.63752",
    stroke: "#8A92A6",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7321 10.8146C16.8113 9.33411 15.5022 7.303 13.3228 7.44478",
    stroke: "#8A92A6",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.955 10.8146C19.0835 8.39113 17.0491 5.1829 13.3364 5.19609",
    stroke: "#8A92A6",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1706 10.8145C21.3486 7.45789 18.4866 3 13.3594 3",
    stroke: "#8A92A6",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17605 13.3634L7.70784 12.7237C7.23633 12.0049 7.14731 11.5334 7.754 10.9036L9.06301 9.54516C9.22788 9.377 9.22788 9.10993 9.06301 8.94177L5.76575 5.63462C5.5943 5.46316 5.31733 5.46646 5.14917 5.64121C5.14917 5.64121 4.22593 6.6106 3.91929 6.93374C2.85098 8.0647 2.72898 9.81884 3.47416 11.1839C3.69178 11.5829 3.88632 12.0115 4.15669 12.4764C4.98101 13.9041 6.47137 15.8001 7.35833 16.6936C8.28816 17.6333 9.91041 19.0083 11.5096 19.9249C12.6306 20.5646 13.5836 21.0064 14.243 21.0724C16.528 21.3032 17.959 19.5853 18.4734 18.8566C18.5954 18.6852 18.5756 18.4511 18.4239 18.3027C17.7348 17.6235 15.8817 15.7737 15.1728 15.0747C15.0113 14.9131 14.7508 14.9098 14.5826 15.0648C14.243 15.3747 13.6858 15.8924 13.2769 16.354C12.7461 16.9541 12.0668 16.931 11.5063 16.5156C11.2128 16.3012 10.3522 15.6385 10.3522 15.6385",
    stroke: "#8A92A6",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21805 14.9493C9.42018 14.9493 9.58404 14.7854 9.58404 14.5833C9.58404 14.3811 9.42018 14.2173 9.21805 14.2173C9.01591 14.2173 8.85205 14.3811 8.85205 14.5833C8.85205 14.7854 9.01591 14.9493 9.21805 14.9493Z",
    fill: "#8A92A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhone);
export default __webpack_public_path__ + "static/media/ic_phone.fa58d28feaf8cb96e4f357608e44022b.svg";
export { ForwardRef as ReactComponent };